module.exports = __webpack_public_path__ + "img/jej5.0c542292.png";